import { ThunkDispatch } from 'store/store';
import { AnyAction } from 'redux';
import { isSetWidgetConfigAction } from 'widgets/store/configuration/actions';
import Services from 'store/Services';

export const widgetConfigMiddleware = (services: Services) => [
    updateOrdersStreamOnConfigChangedMiddleware(services),
];

export function updateOrdersStreamOnConfigChangedMiddleware(
    services: Services
) {
    const { loggingService, widgetsService, ordersStreamingService } = services;

    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        // update the state
        next(action);

        if (!isSetWidgetConfigAction(action)) {
            return;
        }

        const { checkOrderColumnsOnConfigChange } =
            widgetsService.getWidgetStrategy(action.payload!.widgetType);

        if (checkOrderColumnsOnConfigChange) {
            loggingService.debug(
                'updateOrdersStreamOnConfigChangedMiddleware',
                'Checking orders stream for widget config change',
                action
            );
            ordersStreamingService.startOrUpdateOrdersStream();
        }
    };
}
